module.exports = __webpack_public_path__ + "static/media/linkedin.45a676a2.svg";